import {OptionGroup, PrepOption} from "../PrepMenuOptions";
import {Alert, Typography} from "@mui/material";
import {PrepMenu} from "./PrepMenu";
import React from "react";
import {useFixer} from "./Fixer";

export function OneDropdown(props: {
    value: PrepOption;
    onChange(value: Partial<PrepOption>): void;
    group: OptionGroup;
}) {

    const group = props.group;

    const fix = useFixer({
        value: props.value,
        autoFix,
        onChange: props.onChange,
    })

    return (
        <>
            <Typography variant="body2">HW Preps</Typography>
            <div style={{height: 8}}/>
            <PrepMenu id="door-frame" name="Door/Frame"
                      value={props.value}
                      editKey="singleFramePrep" editKeyCustom="singleFramePrepCustomTemplate"
                      editKeyCustomName="singleFramePrepCustomTemplateName"
                      groupKey="singleFramePreps" groupCustomKey="singleFramePrepsCustom"
                      group={group} onChange={v => {
                            props.onChange(autoFix(v));
                        }}/>

            {fix && <Alert severity="warning" style={{marginTop: 8, marginBottom: 8}}>
                Some background properties need to update. Please save product when you're done.
            </Alert>}
        </>
    )
}

function autoFix(input: Partial<PrepOption>) {
    const obj: Partial<PrepOption> = {
        ...input
    };

    if(obj.hasOwnProperty("singleFramePrep")) {
        obj.singleActiveDoorPrep = obj.singleFramePrep;
        obj.pairFramePrep = obj.singleFramePrep;
        obj.pairActiveDoorPrep = obj.singleFramePrep;
        obj.pairInactiveDoorPrep = obj.singleFramePrep;
        obj.pairBothActiveDoorPrep = obj.singleFramePrep;
    }

    if(obj.hasOwnProperty("singleFramePrepCustomTemplate")) {
        obj.singleActiveDoorPrepCustomTemplate = obj.singleFramePrepCustomTemplate;
        obj.singleActiveDoorPrepCustomTemplateName = obj.singleFramePrepCustomTemplateName;
        obj.pairFramePrepCustomTemplate = obj.singleFramePrepCustomTemplate;
        obj.pairFramePrepCustomTemplateName = obj.singleFramePrepCustomTemplateName;
        obj.pairActiveDoorPrepCustomTemplate = obj.singleFramePrepCustomTemplate;
        obj.pairActiveDoorPrepCustomTemplateName = obj.singleFramePrepCustomTemplateName;
        obj.pairInactiveDoorPrepCustomTemplate = obj.singleFramePrepCustomTemplate;
        obj.pairInactiveDoorPrepCustomTemplateName = obj.singleFramePrepCustomTemplateName;
        obj.pairBothActiveDoorPrepCustomTemplate = obj.singleFramePrepCustomTemplate;
        obj.pairBothActiveDoorPrepCustomTemplateName = obj.singleFramePrepCustomTemplateName;
    }

    return obj;
}